document.addEventListener('DOMContentLoaded', function () {
  const full = document.querySelector('.product-description-full');
  const readMore = document.querySelector('.readmore');
  const readLess = document.querySelector('.readless');

  if (full) full.style.display = 'none';

  if (readMore) {
    readMore.addEventListener('click', function (e) {
      e.preventDefault();
      full.style.display = 'block';
      document.querySelector('.product-description-short').style.display = 'none';
    });
  }

  if (readLess) {
    readLess.addEventListener('click', function (e) {
      e.preventDefault();
      full.style.display = 'none';
      document.querySelector('.product-description-short').style.display = 'block';
    });
  }
});